﻿window.GoToTargetPage = function (param) {
    $(".loading-sceen").show();
    getAjaxData("/api/sitecore/Login/GenericGetTargerURL", "POST", false, param, function (data) {
        if (data.success) {
            var url = data.RegistrationUrl;
            $(location).attr('href', url);
        }
        $(".loading-sceen").hide();
    });
};

window.enableDisableEmail = function (enable) {
    if (enable) {
        $('.email').removeAttr('readonly');
        $('.email').attr('style', 'Background:white');
    }
    else {
        $('.email').attr('readonly', 'readonly');
        $('.email').attr('style', 'Background:#f8f8f8');
    }
};

function CustomerLogin() {

    var captcharesponse = document.getElementById('g-recaptcha-response').value;
    var customernumber = $('.CustomerNumber').val();
    var PassWord = $('.password').val();

    var dobday = $(".day-date").val();
    var dobmonth = $(".month-date option:selected").val();
    var dobyear = $(".year-date option:selected").text();

    var pattern = /^[0-9]/
    if (!$('form:eq(0)').valid()) {
        if (captcharesponse == '') {
            $('span[form-name="LoginCaptcha"]').removeClass('hidden').show();
        } else {
            $('span[form-name="LoginCaptcha"]').removeClass('hidden').hide();
        }
        return;
    }

    if ($('.CustomerNumber').val() == "" || $('.password').val() == "" || $(".day-date").val() == "" || $(".month-date option:selected").val() == "" || $(".year-date option:selected").text() == "" || captcharesponse == "") {
        $('span[form-name="Login"]').removeClass('hidden').hide();
        $('span[form-name="LoginCaptcha"]').removeClass('hidden').show();
        return;
    }

    else {

        jQuery.support.cors = true;
        var requesteddatetime = new Date().toISOString();
        var UserPassword = { Password: PassWord, RequestedDateTime: requesteddatetime };
        var jsonUserPassword = JSON.stringify(UserPassword);
        var encryPasswordObject = RsaEncrypt(jsonUserPassword);

        var dob = dobyear + "-" + dobmonth + "-" + dobday;

        dob = dob.replace(/\//g, "-");

        if (!isNaN(customernumber)) {
            var customernumberPrefix = customernumber / 1000000000;
            var customernumberPostfix = customernumber % 1000000000;
            customernumber = parseInt(customernumberPrefix) + "-" + customernumberPostfix;
        }

        $(".loading-screen").show();
        var apiurl = "/api/sitecore/LWCPLogin/Login";

        $.ajax({
            url: apiurl,
            type: 'POST',
            dataType: "json",
            cache: false,
            crossDomain: true,
            processData: true,
            data: {
                "CustomerId": customernumber,
                "Password": encryPasswordObject,
                "DateOfBirth": dob,
                "RequestedDateTime": requesteddatetime,
                "CResponse": captcharesponse
            },
            success: function (responseData, textStatus, jqXHR) {
                if (responseData.IsSuccess) {
                    location.href = responseData.LoginSuccessUrl;
                }
                else {
                    //OnErrorAction(responseData);
                    $('span[form-name="LoginCaptcha"]').removeClass('hidden').hide()
                    $('span[form-name="Login"]').removeClass('hidden').show();
                    $(".loading-screen").hide();
                }
            },
            error: function (responseData, textStatus, errorThrown) {
                //OnErrorAction(responseData, dobday, dobmonth, dobyear);
                $('span[form-name="LoginCaptcha"]').removeClass('hidden').hide()
                $('span[form-name="Login"]').removeClass('hidden').show();
                $(".loading-screen").hide();
            }
        });
    }
}
function UserLogin() {
    var Email = $('.LoginEmail').val();
    var PassWord = $('.LoginPassword').val();
    var pattern = /^[0-9]/
    if (!$('form:eq(0)').valid()) {
        return;
    }

    if ($('.LoginEmail').val() == "" || $('.LoginPassword').val() == "") {
        //$('span[form-name="Login"]').removeClass('hidden').hide();
        //$('span[form-name="LoginCaptcha"]').removeClass('hidden').show();
        return;
    }

    else {
        $(".loading-screen").show();
        var apiurl = "/api/sitecore/MXUserAction/Login";

        $.ajax({
            url: apiurl,
            type: 'POST',
            dataType: "json",
            cache: false,
            crossDomain: true,
            processData: true,
            data: {
                "LoginEmailAddress": Email,
                "PWD": PassWord
            },
            success: function (responseData, textStatus, jqXHR) {
                if (responseData.IsSuccess) {
                    location.href = responseData.LoginSuccessUrl;
                }
                else {
                    //OnErrorAction(responseData);
                    $('span[form-name="LoginCaptcha"]').removeClass('hidden').hide()
                    $('span[form-name="Login"]').removeClass('hidden').show();
                    $(".loading-screen").hide();
                }
            },
            error: function (responseData, textStatus, errorThrown) {
                //OnErrorAction(responseData, dobday, dobmonth, dobyear);
                $('span[form-name="LoginCaptcha"]').removeClass('hidden').hide()
                $('span[form-name="Login"]').removeClass('hidden').show();
                $(".loading-screen").hide();
            }
        });
    }
}

function UserRegistration() {
    var Email = $('.LoginEmail').val();
    var PassWord = $('.LoginPassword').val();
    var pattern = /^[0-9]/
    if (!$('form:eq(0)').valid()) {
        return;
    }

    if ($('.LoginEmail').val() == "" || $('.LoginPassword').val() == "") {
        //$('span[form-name="Login"]').removeClass('hidden').hide();
        //$('span[form-name="LoginCaptcha"]').removeClass('hidden').show();
        return;
    }

    else {
        $(".loading-screen").show();
        var apiurl = "/api/sitecore/MXUserAction/Login";

        $.ajax({
            url: apiurl,
            type: 'POST',
            dataType: "json",
            cache: false,
            crossDomain: true,
            processData: true,
            data: {
                "LoginEmailAddress": Email,
                "PWD": PassWord
            },
            success: function (responseData, textStatus, jqXHR) {
                if (responseData.IsSuccess) {
                    location.href = responseData.LoginSuccessUrl;
                }
                else {
                    //OnErrorAction(responseData);
                    $('span[form-name="LoginCaptcha"]').removeClass('hidden').hide()
                    $('span[form-name="Login"]').removeClass('hidden').show();
                    $(".loading-screen").hide();
                }
            },
            error: function (responseData, textStatus, errorThrown) {
                //OnErrorAction(responseData, dobday, dobmonth, dobyear);
                $('span[form-name="LoginCaptcha"]').removeClass('hidden').hide()
                $('span[form-name="Login"]').removeClass('hidden').show();
                $(".loading-screen").hide();
            }
        });
    }
}

export default class MXLogin {
    constructor() {
        this.dom = {
            $: window.$
        };
        this.init();
    }
    init() {
        //this.onLoad();
        this.submitLoginHome();
        this.loginBackClick();
        this.LoginSubmit();
        this.RedirectFogotPWDFromHomeLogin();
        this.RedirectFogotPWDFromLogin();
        this.RedirectToRegistrationPage();
        this.RedirectToRegistrationForgetPWDPage();
    }

    onLoad() {
        OnLoginPageLoad();
    }

    LoginSubmit() {
        $('.statements-login').click(function (e) {
            UserLogin();
        });
    }
    ForgetPwdSubmit() {
        $('.forgotpwd').click(function (e) {
            if ($('form').valid()) {
                currentpage = "FORGOTPWD";
                $(".loading-screen").show(0, () => {
                    return true;
                });
            }
        });
    }

    RedirectFogotPWDFromHomeLogin() {
        $('.login-home-forgot-pwd-link').click(function (e) {
            GotoForgotPasswordPage();
        });
    }
    RedirectFogotPWDFromLogin() {
        $('.login-forgot-pwd-link').click(function (e) {
            GotoForgotPasswordPage();
        });
    }
    RedirectToRegistrationPage() {
        $('.login-registration-link').click(function (e) {
            GotoRegistrationPage();
        });
    }
    RedirectToRegistrationForgetPWDPage() {
        $('.register-account-link').click(function (e) {
            e.preventDefault();
            var registrationPageGUID = {
                "referenceItem": $('[data-validator-id="register-account-target-item"]').val()
            };
            GoToTargetPage(registrationPageGUID);
        });
        $('.login-forgot-pwd-page-link').click(function (e) {
            e.preventDefault();
            var forgotPWDPageGUID = {
                "referenceItem": $('[data-validator-id="forgot-password-page-item"]').val()
            };
            GoToTargetPage(forgotPWDPageGUID);
        });
    }

    submitLoginHome() {
        $('.login-home-submit').click(function (e) {
            ClearTemporarySession();
            if ($('.email').val().length > 0) {
                event.preventDefault();
                //var isValidationError = ($('.email').closest('.form-row').find('span.form-error').html().length > 0);
                var isValidationError = $('[data-validator-id="login-email-validation-success"]').val();
                if (isValidationError == 'fail') {
                    $('.form').find('.form-error-global').removeClass('hidden');
                }
                else if (isValidationError == 'pass') {
                    var credentialsInputType = {
                        "LoginEmailAddress": $('.email').val(),
                        "PWD": '',
                        "CheckCredentialsType": 'CHECK_EMAIL'
                    };
                    $(".loading-sceen").show();
                    getAjaxData("/api/sitecore/Login/CheckUserCredentials", "POST", true, credentialsInputType, function (data) {
                        if (data) {
                            $('[data-validator-id="login-home-user-token"]').val('');
                            if (!data.success && data.ErrorCode.trim().length > 0)// 'EMAIL_NOT_FOUND' || data.ErrorCode == 'ACCOUNT_LOCKED' || data.ErrorCode == 'WRONG_PWD') {
                            {
                                $('.email').closest('.form-row').find('span.form-error').html(data.ErrorMessage);
                                $('.form').find('.form-error-global').removeClass('hidden');
                                $('.email').closest('.form-row').find('span.form-error').show();
                            }
                            else {
                                $('[data-validator-id="login-home-user-token"]').val(data.UserToken);
                                GotoOTPRegistration();
                            }
                        }
                        $(".loading-sceen").hide();
                    });
                }
            }
        });
    }

    //signIn() {
    //    $('.login-sign-in').click(function (e) {
    //        event.preventDefault();
    //        //alert('dfdf');
    //        //if ($('.email').val().length > 0 && $('.password').val().length > 0) {
    //        //    event.preventDefault();
    //        //    var isValidationError = ($('.email').closest('.form-row').find('span.form-error').html().length > 0);
    //        //    if (isValidationError) {
    //        //        $('.form').find('.form-error-global').removeClass('hidden');
    //        //    }
    //        //    else {
    //        var credentialsInputType = {
    //            "LoginEmailAddress": $('.email').val(),
    //            "PWD": $('.password').val(),
    //            "CheckCredentialsType": 'CHECK_EMAIL_AND_PWD'
    //        };
    //        //        $(".loading-sceen").show();
    //        getAjaxData("/api/sitecore/Login/LogIn", "POST", false, credentialsInputType, function (data) {
    //            if (data) {
    //                location.reload();
    //                //if (data.ErrorCode == 'EMAIL_NOT_FOUND' || data.ErrorCode == 'ACCOUNT_LOCKED') {
    //                //    $('.email').closest('.form-row').find('span.form-error').html(data.ErrorMessage);
    //                //    $('.form').find('.form-error-global').removeClass('hidden');
    //                //    $('.email').closest('.form-row').find('span.form-error').show();
    //                //}
    //                //else {
    //                //if (data.LoginRegistrationScreenFlow == 'PASSWORD_ALREDY_SET') {
    //                //$('.form').find('.form-error-global').addClass('hidden');
    //                //$('.login-div').show();
    //                //$('.login-home-div').hide();

    //                //$('.email').attr('disabled', 'disabled');
    //                //}
    //                //else {
    //                //    $('.form').find('.form-error-global').addClass('hidden');
    //                //    $('.login-otp-div').show();
    //                //    $('.login-home-div').hide();
    //                //}
    //            }
    //            //$(".loading-sceen").hide();
    //            //}
    //        });
    //        //    }
    //        //}
    //    });
    //}

    loginBackClick() {
        $('.login-back').click(function (e) {
            ClearTemporarySession();

            event.preventDefault();
            $('.form').find('.form-error-global').addClass('hidden');
            $('.password').closest('.form-row').find('span.form-error').html('');
            $('.login-div').hide();
            $('.login-sign-in').attr('type', '').prop('disabled', true);
            $('.login-home-div').show();
            $('.login-home-submit').attr('type', 'submit').prop('disabled', false);

            //enableDisableEmail(true);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => new MXLogin());